import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  emptyState: {
    border: "1px solid ".concat(palette.shades[300]),
    padding: '60px 0',
    textAlign: 'center'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '32px 0 40px 0',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      '& .MuiButton-root': {
        width: '100%'
      }
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      '& .MuiButton-root + .MuiButton-root': {
        marginTop: '10px',
        marginLeft: '0'
      }
    }
  },
  totalSummaryWrapper: {
    marginTop: '20px',
    padding: '24px 32px',
    backgroundColor: palette.shades[100],
    boxShadow: palette.shadows.light,
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-end'
    }
  },
  total: {
    marginLeft: '4px'
  },
  topActionDatepicker: {
    paddingRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      paddingRight: '0',
      paddingBottom: '20px',
      '& .MuiButton-root': {
        width: '100%'
      }
    }
  }
}));
export default useStyles;